import { Box, Shimmer } from "@jewlr/storybook/core"
import React from "react"

const WizardPricingLoading = () => (
  <Box mb="12px" textAlign={{ _: "center", tablet: "left" }}>
    <Shimmer
      height="32px"
      mb="2px"
      mx={{ _: "auto", tablet: 0 }}
      width="80px"
    />
    <Shimmer height="14px" mx={{ _: "auto", tablet: 0 }} width="280px" />
  </Box>
)

export default WizardPricingLoading
